import API from "@/api/serverCall";
import { UserInviteResponseDto, UserResponseDto } from "@/api/interface";

export function getUserList(): Promise<UserResponseDto[]> {
	return new Promise((resolve, reject) => {
		API.get<UserResponseDto[]>({
			link: `/user/list`,
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}

export function postUserInvite(body: {
	email: string[];
}): Promise<UserInviteResponseDto[]> {
	return new Promise((resolve, reject) => {
		API.post<UserInviteResponseDto[]>({
			link: "/user/invite",
			body,
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}

export function deleteUser(id: number): Promise<string> {
	return new Promise((resolve, reject) => {
		API.delete<string>({
			link: `/user/${id}`,
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}

export function patchUserOwner(id: number): Promise<string> {
	return new Promise((resolve, reject) => {
		API.patch<string>({
			link: `/user/owner/${id}`,
		})
			.then((res) => {
				resolve(res.data);
			})
			.catch((e) => {
				reject(e);
			});
	});
}
